/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  MachineChecklistCategory,
} from '../models/index';
import {
    MachineChecklistCategoryFromJSON,
    MachineChecklistCategoryToJSON,
} from '../models/index';

export interface CreateCategoryRequest {
    machineChecklistCategory: MachineChecklistCategory;
}

export interface DeleteCategoryRequest {
    id: string;
}

export interface GetCategoryRequest {
    id: string;
}

export interface UpdateCategoryRequest {
    id: string;
    machineChecklistCategory: MachineChecklistCategory;
}

/**
 * 
 */
export class MachineChecklistCategoryControllerApi extends runtime.BaseAPI {

    /**
     */
    async createCategoryRaw(requestParameters: CreateCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MachineChecklistCategory>> {
        if (requestParameters['machineChecklistCategory'] == null) {
            throw new runtime.RequiredError(
                'machineChecklistCategory',
                'Required parameter "machineChecklistCategory" was null or undefined when calling createCategory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/checklist-categories`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MachineChecklistCategoryToJSON(requestParameters['machineChecklistCategory']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MachineChecklistCategoryFromJSON(jsonValue));
    }

    /**
     */
    async createCategory(requestParameters: CreateCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MachineChecklistCategory> {
        const response = await this.createCategoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteCategoryRaw(requestParameters: DeleteCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteCategory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/checklist-categories/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteCategory(requestParameters: DeleteCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCategoryRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getAllCategoriesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MachineChecklistCategory>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/checklist-categories`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MachineChecklistCategoryFromJSON));
    }

    /**
     */
    async getAllCategories(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MachineChecklistCategory>> {
        const response = await this.getAllCategoriesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getCategoryRaw(requestParameters: GetCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MachineChecklistCategory>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getCategory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/checklist-categories/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MachineChecklistCategoryFromJSON(jsonValue));
    }

    /**
     */
    async getCategory(requestParameters: GetCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MachineChecklistCategory> {
        const response = await this.getCategoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateCategoryRaw(requestParameters: UpdateCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MachineChecklistCategory>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateCategory().'
            );
        }

        if (requestParameters['machineChecklistCategory'] == null) {
            throw new runtime.RequiredError(
                'machineChecklistCategory',
                'Required parameter "machineChecklistCategory" was null or undefined when calling updateCategory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/checklist-categories/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MachineChecklistCategoryToJSON(requestParameters['machineChecklistCategory']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MachineChecklistCategoryFromJSON(jsonValue));
    }

    /**
     */
    async updateCategory(requestParameters: UpdateCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MachineChecklistCategory> {
        const response = await this.updateCategoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
